import { render, staticRenderFns } from "./EditSize.vue?vue&type=template&id=54d14194&scoped=true"
import script from "./EditSize.vue?vue&type=script&lang=js"
export * from "./EditSize.vue?vue&type=script&lang=js"
import style0 from "./EditSize.vue?vue&type=style&index=0&id=54d14194&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d14194",
  null
  
)

export default component.exports